module.exports = __webpack_public_path__ + "img/Core_s5_b0_0_1_C00_UK.f76d1b13.png";